import React from 'react';

const FacebookLogo = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.375 30H17.7159V17.0293H21.8636L22.5455 11.875H17.7159V8.30664C17.7159 7.51367 17.8295 6.89062 18.1705 6.49414C18.5114 6.04102 19.25 5.81445 20.2727 5.81445H23V1.22656C21.9773 1.11328 20.6136 1 19.0227 1C16.9773 1 15.3864 1.62305 14.1932 2.8125C12.9432 4.00195 12.375 5.64453 12.375 7.79688V11.875H8V17.0293H12.375V30Z"
      fill="#003E7D"
    />
  </svg>
);

export default FacebookLogo;
